import { render } from "./GlMsgResult.vue?vue&type=template&id=74caa500&scoped=true"
import script from "./GlMsgResult.vue?vue&type=script&lang=js"
export * from "./GlMsgResult.vue?vue&type=script&lang=js"

import "./GlMsgResult.vue?vue&type=style&index=0&id=74caa500&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74caa500"

export default script